<script>

export default {
    name: "ConsultantPaymentTab",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 
                rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    components: {

        "create-voucher-form": () => import('./tabs/Form.vue'),
        "pending-vouchers": () => import('./tabs/PendingVouchers.vue'),
        "posted-vouchers": () => import('./tabs/PostedVouchers.vue'),
        "consultant-statement": () => import('./tabs/Statement.vue'),
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <ul class="print:hidden w-full flex border-b-2 border-gray-500 mt-1">
            <li class="-mb-px mr-1">
                <a @click.prevent="active=0" href="javascript:void(0)" 
                  class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold" 
                  :class="active===0 ? activeClass : inActiveClass">Create Voucher</a>
            </li>
            <li class="-mb-px mr-1">
                <a @click.prevent="active=1" href="javascript:void(0)" 
                  class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold" 
                  :class="active===1 ? activeClass : inActiveClass">Pending Vouchers</a>
            </li>
            <li class="-mb-px mr-1">
                <a @click.prevent="active=2" href="javascript:void(0)" 
                  class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold" 
                  :class="active===2 ? activeClass : inActiveClass">Posted Vouchers</a>
            </li>
            <li class="-mb-px mr-1">
                <a @click.prevent="active=3" href="javascript:void(0)" 
                  class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold" 
                  :class="active===3 ? activeClass : inActiveClass">Statement</a>
            </li>
        </ul>
        <create-voucher-form v-if="active===0"/>
        <pending-vouchers v-if="active===1"/>
        <posted-vouchers v-if="active===2" />
        <consultant-statement v-if="active===3" />
    </div>
</template>
<style>
@media print {
    .overflow-auto {
        overflow: visible !important;
    }
}
</style>
